import {
    Button,
    Col,
    Grid,
    Heading,
    Message,
    Row,
    Stack,
    toaster,
} from "rsuite";
import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import * as XLSX from "xlsx";

import useAxiosPrivate from "app/hooks/useAxiosPrivate";
import { findDuplicateIds, hasInvalidIds, mergeArraysById } from "functions";
import { LoadingButton } from "@mui/lab";

import AgGrid from "app/components/AgGrid";
import moment from "moment";


const columns = [
    { id: "ID", label: "ID", Width: 200 },
    { id: "InvoiceID", label: "InvoiceID", Width: 200 },
    { id: "Date", label: "Date", Width: 200 },
    { id: "NoOfTxn", label: "NoOfTxn", minWidth: 200 },
    { id: "NoOfCheque", label: "NoOfCheque", minWidth: 200 },
    { id: "NoOfPolicies", label: "NoOfPolicies", minWidth: 200 },
    { id: "TotalCash", label: "TotalCash", minWidth: 200 },
    { id: "TotalChequeAmnt", label: "TotalChequeAmnt", minWidth: 200 },
    { id: "TotalInvoiceAmnt", label: "TotalInvoiceAmnt", minWidth: 200 },
    { id: "ValidationID", label: "ValidationID", Width: 200 },
    { id: "PayDate", label: "PayDate", Width: 200 },
    { id: "MerchantID", label: "MerchantID", Width: 200 },
    { id: "CashierName", label: "CashierName", Width: 200 },
    { id: "Remark", label: "Remark", minWidth: 200 },
    { id: "UploadStatus", label: "UploadStatus", Width: 100 },
    { id: "Message", label: "Message", minWidth: 500 },
];
const columns1 = [
    { id: "ID", field: "ID", Width: 200, visible: true },
    { id: "InvoiceID", field: "InvoiceID", Width: 200 },
    { id: "Date", field: "Date", Width: 200 },
    { id: "NoOfTxn", field: "NoOfTxn", minWidth: 200 },
    { id: "NoOfCheque", field: "NoOfCheque", minWidth: 200 },
    { id: "NoOfPolicies", field: "NoOfPolicies", minWidth: 200 },
    { id: "TotalCash", field: "TotalCash", minWidth: 200 },
    { id: "TotalChequeAmnt", field: "TotalChequeAmnt", minWidth: 200 },
    { id: "TotalInvoiceAmnt", field: "TotalInvoiceAmnt", minWidth: 200 },
    { id: "ValidationID", field: "ValidationID", Width: 200 },
    { id: "PayDate", field: "PayDate", Width: 200 },
    { id: "MerchantID", field: "MerchantID", Width: 200 },
    { id: "CashierName", field: "CashierName", Width: 200 },
    { id: "Remark", field: "Remark", minWidth: 200 },
    { id: "UploadStatus", field: "UploadStatus", Width: 100 },
    { id: "Message", field: "Message", minWidth: 500 },
];
const rows = [];

export default function ImportLICImport() {
    const [page, setPage] = React.useState(0);
    const [data, setData] = React.useState([]);
    const [status, setStatus] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const axiosPrivate = useAxiosPrivate();
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const DownloadTemplate = () => {
        // Acquire Data (reference to the HTML table)
        var table_elt = document.getElementById("TableData");

        // Extract Data (create a workbook object from the table)
        var workbook = XLSX.utils.table_to_book(table_elt);

        // Process Data (add a new row)
        //var ws = workbook.Sheets["Sheet1"];
        /* XLSX.utils.sheet_add_aoa(ws, [["Created " + new Date().toISOString()]], {
            origin: -1,
          }); */

        // Package and Release Data (`writeFile` tries to write and save an XLSB file)
        XLSX.writeFile(workbook, "LICInvoiceDataTemplate.xlsb");
    };


    const handleUpload = (e) => {
        try {
            setData(rows);
            e.preventDefault();

            var files = e.target.files,
                f = files[0];
            var reader = new FileReader();
            reader.onload = function (e) {
                var data = e.target.result;
                let readedData = XLSX.read(data, { type: "binary" });
                const wsname = readedData.SheetNames[0];
                const ws = readedData.Sheets[wsname];

                /* Convert array to json*/
                const dataParse = XLSX.utils.sheet_to_json(ws, { header: 0 });
                //console.log(dataParse);
                const newData = dataParse.map((row, index) => {
                    //console.log(row);
                    let excelDate = row.Date; // Replace with the correct cell reference

                    // Convert Excel date to JavaScript Date
                    let jsDate = new Date((excelDate - 25569) * 86400 * 1000);

                    // Format the date as needed (e.g., YYYY-MM-DD for MySQL)
                    let date = jsDate.toISOString().split("T")[0];

                    let excelPayDate = row.PayDate; // Replace with the correct cell reference

                    // Convert Excel date to JavaScript Date
                    let jsPayDate = new Date((excelPayDate - 25569) * 86400 * 1000);

                    // Format the date as needed (e.g., YYYY-MM-DD for MySQL)
                    let formattedPayDate = jsPayDate.toISOString().split("T")[0];


                    return {
                        ...row,
                        Date: moment(date).format("YYYY-MM-DD"),
                        PayDate: moment(formattedPayDate).format("YYYY-MM-DD"),
                    };
                });
                console.log(newData);
                setData(newData);
                // updateQueryParams(newData);
            };
            reader.readAsBinaryString(f);
        } catch (error) {
            toaster.push(<Message type="error">Error occured</Message>);
        }
    };
    function onGridReady() { }
    /*   function onGridReady() {}
    const history = useNavigate();
    const location = useLocation();
    const updateQueryParams = React.useCallback(
      (activeKey) => {
        const params = new URLSearchParams(location.search);
        params.set("data", JSON.stringify(activeKey));
        history(`?${params.toString()}`, { replace: true });
      },
      [history, location.search]
    );
  
    React.useEffect(() => {
      const params = new URLSearchParams(location.search);
      const nameFromParams = params.get("data");
  
      if (nameFromParams) {
        setData(JSON.parse(nameFromParams));
      }
    }, [location.search]); */

    async function handleImport() {
        setStatus(true);
        if (data.length > 0) {
            const duplicates = findDuplicateIds(data);
            if (hasInvalidIds(data)) {
                console.log("Invalid IDs found:");
                toaster.push(
                    <Message type="error" bordered showIcon>
                        <strong>Invalid IDs!</strong> {`There are some invalid IDs`}
                    </Message>
                );
                setStatus(false);
                return;
            } else if (duplicates.length > 0) {
                console.log("Duplicate IDs found:");
                toaster.push(
                    <Message type="error" bordered showIcon>
                        <strong>Duplicate IDs!</strong>{" "}
                        {`Duplicate IDs found - ${duplicates.toString()}`}
                    </Message>
                );
                setStatus(false);
                return;
            } else {
                try {
                    //  alert("Work in progress");
                    // return;
                    axiosPrivate
                        .post("ImportLICInvoiceData.php", {
                            data,
                        })
                        .then((response) => {
                            const result = response.data;
                            if (result.status === 1) {
                                toaster.push(
                                    <Message type="success" bordered showIcon>
                                        <strong>Success!</strong> {result.Success}
                                    </Message>
                                );
                                const newData = mergeArraysById(data, result.Data);
                                //console.log(newData);
                                setData(newData);
                                //updateQueryParams(newData);
                            }
                            if (result.status === 0) {
                                toaster.push(
                                    <Message type="error" bordered showIcon>
                                        <strong>Error!</strong> {result.Error}
                                    </Message>
                                );
                            }
                            setStatus(false);
                            // resetForm();
                        })
                        .catch((error) => {
                            console.error("Error submitting data:", error);
                            setStatus(false);
                        });
                } catch (error) {
                    console.error(error);
                    setStatus(false);
                }
            }
        } else {
            toaster.push(
                <Message type="error" bordered showIcon>
                    Please upload a file first
                </Message>
            );
            setStatus(false);
        }
    }

    return (
        <>
            <div
                style={{ width: "100%", border: "0.5px dashed #999", borderRadius: 10 }}
            >
                <Heading level={5} style={{ textAlign: "center" }}>
                    Import Premium Point
                </Heading>
            </div>
            <div
                style={{
                    width: "100%",
                    margin: "10px 0px 10px 0px",
                    padding: 5,
                    border: "0.5px dashed #999",
                    borderRadius: 10,
                }}
            >
                <Stack direction="row" spacing={4}>
                    <Button onClick={DownloadTemplate}>Download Template</Button>

                    <input
                        type="file"
                        onChange={handleUpload}
                        onInput={handleUpload}
                        onSelect={handleUpload}
                    />
                    <LoadingButton
                        disabled={status}
                        type="submit"
                        color="secondary"
                        variant="contained"
                        onClick={handleImport}
                        loading={status}
                        sx={{ my: 2 }}
                    >
                        {status ? "Uploading..." : "Import"}
                    </LoadingButton>
                </Stack>
            </div>
            <div
                style={{
                    width: "100%",
                    minHeight: 600,
                    border: "0.5px dotted #999",
                    marginTop: 5,
                    borderRadius: 10,
                }}
            >
                <Grid fluid style={{ padding: 10 }}>
                    <Row className="show-grid">
                        <Col xs={24} sm={24} md={24}>
                            <Paper style={{ display: "none" }}>
                                <TableContainer sx={{ maxHeight: 440, overflowX: "auto" }}>
                                    <Table
                                        stickyHeader
                                        className={{}}
                                        aria-label="sticky table"
                                        id="TableData"
                                    >
                                        <TableHead>
                                            <TableRow>
                                                {columns.map((column) => (
                                                    <TableCell key={column.id} align={column.align}>
                                                        {column.label}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(data || rows)
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((row, index) => {
                                                    return (
                                                        <TableRow
                                                            hover
                                                            role="checkbox"
                                                            tabIndex={-1}
                                                            key={index}
                                                        >
                                                            {columns.map((column) => {
                                                                const value = row[column.id];
                                                                return (
                                                                    <TableCell
                                                                        key={column.id + value}
                                                                        align={column.align}
                                                                    >
                                                                        {column.format && typeof value === "number"
                                                                            ? column.format(value)
                                                                            : value}
                                                                    </TableCell>
                                                                );
                                                            })}
                                                        </TableRow>
                                                    );
                                                })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    component="div"
                                    count={rows.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    rowsPerPageOptions={[
                                        10,
                                        50,
                                        100,
                                        { value: -1, label: "All" },
                                    ]}
                                />
                            </Paper>
                            <Row className="show-grid" style={{ maxHeight: 350 }}>
                                <AgGrid
                                    columns={columns1}
                                    rowData={data}
                                    onGridReady={onGridReady}
                                    defaultColumn={["ID", "InvoiceID", "Date", "PayDate"]}
                                    showHeaderItems={false}
                                    GoTo="/Prospects/AddProspect"
                                    passdata={false}
                                    settingsName="LICInvoice"
                                    Source="LICInvoice"
                                />
                            </Row>
                        </Col>
                    </Row>
                </Grid>
            </div>
        </>
    );
}

